import React, { useEffect, useState } from "react";
import { useIsFocused, useNavigation, useRoute } from "@react-navigation/native";
import i18n from "utils/i18n";
import _ from "lodash";
import ThemedSafeAreaComponentTop from "components/atoms/ThemedSafeAreaTop";
import ThemedLayout from "components/atoms/ThemedLayout";
import LoadingComponent from "components/atoms/Loading";
import { FormStatus } from 'utils/constants/form-constants';
import GraphqlBuilder from "utils/request/graphql/builder";
import TabbedContent from 'components/molecules/TabbedContent'
import HelperString from 'utils/helper-string'
import { useSelector } from 'react-redux'
import { dataConstants } from 'services/redux/data/constants'
import QueryManagementEmailTemplate from 'graphql/queries/management/QueryManagementEmailTemplate'
import ObjectEmail from 'utils/objects/email'
import EmailData from 'scenes/management/emails/components/email/data'
import { createTranslationMutationParameters } from 'components/molecules/Form'
import MutationManagementEmailTemplate from 'graphql/mutations/management/MutationManagementEmailTemplate'
import ManagementAppMessagesIndexScene from 'scenes/management/app_messages/index'
import QueryManagementAppMessage from 'graphql/queries/management/QueryManagementAppMessage'
import AppMessageData from 'scenes/management/app_messages/components/appMessage/data'
import MutationManagementAppMessage from 'graphql/mutations/management/MutationManagementAppMessage'
import HelperDate, { dateFormat } from 'utils/helper-date'

const ManagementAppMessagesEditScene = () => {
	
	const navigation = useNavigation();
	const isFocused = useIsFocused();
	const route = useRoute();
	
	const _languages = useSelector( state => {
		return state.data[dataConstants.LANGUAGES];
	} )
	
	const [ loading, setLoading ] = useState( true )
	const [ appMessage, setAppMessage ] = useState( {} )
	
	const guid = _.get( route.params, 'guid', null );
	
	const fetch = () => {
		if( guid !== null ) {
			new GraphqlBuilder()
				.addQuery( 'query', QueryManagementAppMessage, {
					guid: guid
				})
				.setResultPath( ['query', 'app_message'], {} )
				.setOnSuccess( result => {
					setLoading( false )
					setAppMessage( result )
				})
				.setOnError( setLoading.bind( this, false ) )
				.execute()
			
			return;
		}
		
		setLoading( false )
		setAppMessage( ObjectEmail.defaults )
	}
	
	const saveForm = ( values, { callback } = {} ) => {
		
		const parameters = createTranslationMutationParameters( values );
		
		values['guid'] = guid;
		values['translations'] = JSON.stringify( parameters )
		values['date_start'] = HelperDate.date( values?.dates?.[ 0 ] ).format( dateFormat.DATE )
		values['date_end'] = HelperDate.date( values?.dates?.[ 1 ] ).format( dateFormat.DATE )
		
		new GraphqlBuilder()
			.addQuery( 'mutation', MutationManagementAppMessage, values )
			.setResultPath( ['mutation', 'app_message'], {} )
			.setOnStart( () => {
				callback( FormStatus.LOADING )
			})
			.setOnSuccess( ( result ) => {
				callback( FormStatus.SUCCESS )
				
				fetch()
			})
			.setOnError( ( result ) => {
				callback( FormStatus.ERROR )
			})
			.execute()
	}
	
	useEffect( () => {
		return fetch();
	}, [ isFocused, guid ] )
	
	if( loading ) {
		return (
			<LoadingComponent />
		)
	}
	
	const tabBarItems = []
	
	// Data
	tabBarItems.push({
		key: 'data',
		text: i18n.t( 'management:form_block.title_default' ),
		scene: ( props ) => {
			return (
				<AppMessageData
					key={ HelperString.hash( 'app-message-data', appMessage ) }
					{ ...props }
					appMessage={ appMessage }
					saveForm={ saveForm }
				/>
			);
		}
	});
	
	return (
		<ThemedSafeAreaComponentTop
			top={ false }>
			
			<ThemedLayout
				title={ i18n.t('management:pages.app_messages.edit.title') }
				topNavigation={true}
				showBackButton={true}>
				
				<TabbedContent
					items={ tabBarItems }
				/>
			</ThemedLayout>
		</ThemedSafeAreaComponentTop>
	)
}

export default ManagementAppMessagesEditScene
